export default "__VITE_ASSET__4e6e7373__"